import { render, staticRenderFns } from "./ListNews.vue?vue&type=template&id=24b7afb5&"
import script from "./ListNews.vue?vue&type=script&lang=ts&"
export * from "./ListNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports